// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"styles_modalContent__oxDjU"};